import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  user: {
    email: '',
    accessToken: '',
    name: '',
    roles: [],
    imageData: '',
    isSsoUser: false
  },
  clients: [],
  currentClient: '',
  currentClientId: null,
  currentClientName: '',
  currentClientACPReview: false,
  currentClientHeaderTextReviews: '',
  baseApiUrl: ''
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
